import { driveTimeFilter } from '../featureFlags'
import useFeatureFlag from '../hooks/useFeatureFlag'
import { useVisitorOriginQuery } from '../hooks/useQueries'

type VisitorOrigin = {
  coordinates: [number, number]
  /** 'explicit' only after the visitor shared their precise location */
  source: string
}

// Client-only on purpose: the origin is viewer-dependent, so it must stay out
// of the SSR-seeded search document.
const useVisitorOrigin = (): VisitorOrigin | null => {
  const flagEnabled = useFeatureFlag(driveTimeFilter)
  const { data } = useVisitorOriginQuery({ skip: !flagEnabled })

  const origin = data?.driveTimes?.visitorOrigin

  return origin
    ? {
        coordinates: [origin.latitude, origin.longitude],
        source: origin.source,
      }
    : null
}

export default useVisitorOrigin
